export interface VasRuleActionTypes {
  type: VasRuleActions;
  payload?: any;
}

export enum VasRuleActions {
  CREATE_VAS_RULE = "CREATE_VAS_RULE",
  GET_VAS_RULE_LIST = "GET_VAS_RULE_LIST",
  SET_VAS_RULE_LIST = "SET_VAS_RULE_LIST",
  SET_VAS_RULE_LIST_PAGE_COUNT = "SET_VAS_RULE_LIST_PAGE_COUNT",
  GET_VAS_RULE_DATA_BY_ID = "GET_VAS_RULE_DATA_BY_ID",
  SET_VAS_RULE_DATA_BY_ID = "SET_VAS_RULE_DATA_BY_ID",
  EDIT_VAS_RULE_DATA_BY_ID = "EDIT_VAS_RULE_DATA_BY_ID",
}
